import React, {useMemo, useState} from 'react';
import {
    MaterialReactTable,
    type MRT_ColumnDef,
    type MRT_ColumnFiltersState,
    MRT_EditActionButtons,
    type MRT_Row,
    useMaterialReactTable,
} from 'material-react-table';
import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Stack,
    Tooltip,
} from '@mui/material';
import {QueryClient,} from '@tanstack/react-query';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

import {useNavigate} from "react-router-dom";

import {useDeletePianAtt, useGetPianAttDTO} from "./Services";
import {PianAttDTO} from "./types";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PianAttExp from "./PianAttExp";
import {useTabSettings} from "../../common/Services";
import AddPianAtt2 from "./AddPianAtt2";

interface ListaPianAttProps {
  // propflgtemp: string;
}

const ListaPianAtt: React.FC<ListaPianAttProps> = () => {
  const [validationErrors, setValidationErrors] = useState< Record<string, string | undefined>>({});

  const [globalFilter, setGlobalFilter] = useState('');

  const navigate = useNavigate();

  const [isDialogExporterOpen, setIsDialogExporterOpen] = useState(false);


const getRowStyle = (priorita: string) => {

  switch (priorita) {
    case 'High':
      return { backgroundColor: '#FFCCCC' }; // Red for high priority
    case 'Medium':
      return { backgroundColor: '#FFFF99' }; // Yellow for medium priority
    case 'Low':
      return { backgroundColor: '#CCFFCC' }; // Green for low priority
    default:
      return {};
  }
};



  const columns = useMemo<MRT_ColumnDef<PianAttDTO>[]>(
  () => [
    {
      accessorKey: 'id',
      header: 'ID',
      size: 5,
      enableEditing: false,
    },
    // {
    //   accessorKey: 'ditta',
    //   header: 'Ditta',
    //   size: 5,
    //   enableEditing: false,
    // },
    // {
    //   accessorKey: 'idcli',
    //   header: 'IdCli',
    //   size: 10,
    // },
   { accessorKey: 'ragsoccli', header: 'Cliente', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 10 ? `${value.substring(0, 10)}...` : value}</span> ); }, },
    // {
    //   accessorKey: 'codprog',
    //   header: 'CodProg',
    //   size: 10,
    // },
    { accessorKey: 'desprog', header: 'Progetto', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 20 ? `${value.substring(0, 20)}...` : value}</span> ); }, },

    // {
    //   accessorKey: 'codnodo',
    //   header: 'CodNodo',
    //   size: 10,
    // },
     { accessorKey: 'desnodo', header: 'Nodo', size: 2, enableEditing: false,Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 10 ? `${value.substring(0, 10)}...` : value}</span> ); }, },

    {
      accessorKey: 'ref',
      header: 'Ref',
      size: 5,
      enableEditing: false,
    },
    {
      accessorKey: 'coddip',
      header: 'Dip',
      size: 5,
    },
    {
      accessorKey: 'priorita',
      header: 'Priorità',
      size: 5,
    },
    {
      accessorKey: 'datainiziopian',
      header: 'InizioPian',
      enableEditing: true,
      filterVariant: "date-range",
      size: 5,
        Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
    },
    {
      accessorKey: 'datafinepian',
      header: 'FinePian',
      enableEditing: true,
      filterVariant: "date-range",
      size: 5,
        Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
    },
      {
          accessorKey: 'datainizioeff',
          header: 'InizioEff',
          enableEditing: true,
          filterVariant: "date-range",
          size: 5,
          Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
      },
    {
      accessorKey: 'datafineeff',
      header: 'FineEff',
      enableEditing: true,
      filterVariant: "date-range",
      size: 5,
      Cell: ({cell}) => {
              const value = cell.getValue();
              if (value && (typeof value === 'string' || typeof value === 'number' || value instanceof Date)) {
                  const date = new Date(value);
                  return new Intl.DateTimeFormat('it-IT', {day: '2-digit',  month: '2-digit', year: '2-digit' }).format(date);
              } else {
                  return '';
              }
          }
    },
{ accessorKey: 'note', header: 'Note', size: 2, enableEditing: false,  Cell: ({ cell }) => {const value = (cell.getValue() ?? '') as string; return (<span title={value}> {value.length > 80 ? `${value.substring(0, 80)}...` : value}</span> ); }, },


      ],
 [validationErrors]
);






  const keyusername = localStorage.getItem('keyusername') || 'NN';
  const {  columnVisibility,  setColumnVisibility,  columnFilters,  setColumnFilters,  sorting,  setSorting, pagination,  setPagination,  saveTabSettings,} = useTabSettings('ListaPianAtt', keyusername);
  const [draftColumnFilters, setDraftColumnFilters] = useState<MRT_ColumnFiltersState>(columnFilters);



  const { data: { results = [], count } = {}, isError: isLoadingPianAttDTOError, isFetching: isFetchingPianAttDTO, isLoading: isLoadingPianAttDTO } = useGetPianAttDTO(pagination, columnFilters, globalFilter, sorting);
  // const {  data: { results = [], count } = {} ,isError: isLoadingPrevTestaError, isFetching: isFetchingPrevTesta, isLoading: isLoadingPrevTesta, } = useGetAllPianAtt(pagination,columnFilters,globalFilter,sorting);
  const { mutateAsync: deletePianAtt, isPending: isDeletingPianAtt } = useDeletePianAtt();


  const [isDialogEditOpen, setIsDialogEditOpen] = useState(false);
  const [currentRowId, setCurrentRowId] = useState('0');
  const [isDialogAddOpen, setIsDialogAddOpen] = useState(false);


const openDeleteConfirmModal = async (row: MRT_Row<PianAttDTO>) => {
  const id = Number(row.original.id);

  if (isNaN(id) || id === 0) {
    console.error("Invalid ID:", row.original.id);
    return;
  }

  const confirmed = window.confirm(
    `ATTENZIONE !!! CANCELLAZIONE DEL ... "${id}"`
  );

  if (!confirmed) return;

  try {
    await deletePianAtt(id);
  } catch (error) {
    console.error("Errore durante la cancellazione:", error);
    alert("Errore durante la cancellazione");
  }
};


  const openAddModal = () => {
        setIsDialogAddOpen(true);
  };


  const openEditModal = (row: MRT_Row<PianAttDTO>) => {
       setIsDialogEditOpen(true);
       setCurrentRowId(row.id);
   };



  const table = useMaterialReactTable({
    columns,
    data: results,
    initialState: { density: 'compact' },

    manualFiltering: true, //turn off built-in client-side filtering
    manualPagination: true, //turn off built-in client-side pagination
    manualSorting: true, //turn off built-in client-side sorting

    enableColumnActions: false,

    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,

    /*
    muiPaginationProps: {
      disabled: isFetchingPianAtt,
    },
    */

    getRowId: (row) => (row.id ? row.id.toString() : ''),


                // muiTableBodyRowProps: ({ row }) => {
                //   // console.log(row);  // Log the full row object
                //   const rowPriorita = row.original.priorita ? row.original.priorita : '';
                //   return {
                //     // style: getRowStyle(rowPriorita),
                //       style: { backgroundColor: 'red'},
                //   };
                // },

        // muiTableBodyRowProps: ({ row }) => {
        //   const rowPriorita = row.original.priorita ? row.original.priorita : '';
        //   return {
        //     style: { backgroundColor: 'red' },
        //   };
        // },




    muiToolbarAlertBannerProps: isLoadingPianAttDTOError ? {
          color: 'error',
          children: 'Error loading data',
        } : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: '500px',
      },
    },
    // muiEditRowDialogProps: {
    //    fullWidth: true,
    //    maxWidth: 'md',
    //  },


    onColumnFiltersChange: setDraftColumnFilters,
    // onColumnFiltersChange: (updater) => {
    //   const newFilters = typeof updater === 'function' ? updater(columnFilters) : updater;
    //   setColumnFilters(newFilters);
    //   saveTabSettings(columnVisibility, newFilters, sorting, pagination);
    // },
    onSortingChange: (updater) => {
      const newSorting = typeof updater === 'function' ? updater(sorting) : updater;
      setSorting(newSorting);
      saveTabSettings(columnVisibility, columnFilters, newSorting, pagination);
    },
    onPaginationChange: (updater) => {
      const newPagination = typeof updater === 'function' ? updater(pagination) : updater;
      setPagination(newPagination);
      saveTabSettings(columnVisibility, columnFilters, sorting, newPagination);
    },

    onColumnVisibilityChange: (updater) => {
      const newVisibility = typeof updater === 'function' ? updater(columnVisibility) : updater;
      setColumnVisibility(newVisibility);
      saveTabSettings(newVisibility, columnFilters, sorting,pagination);
    },



    onCreatingRowCancel: () => setValidationErrors({}),
    onEditingRowCancel: () => setValidationErrors({}),

     renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
         <>
        <DialogTitle variant="h3">Crea Nuovo </DialogTitle>
        <DialogContent
           sx={{ width: '1000px'}}
        >
          {internalEditComponents} {/* or render custom edit components here */}

        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>

       </>
    ),


   renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit PrevTesta</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '0.20rem' }}>


       <Tooltip title="Modifica">
          <IconButton   onClick={() =>  openEditModal(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>

       {/*{isDialogEditOpen && currentRowId === row.id && <EditPianAtt open propidattivita={(currentRowId.trim())} onClose={()  => setIsDialogEditOpen(false) } />}*/}

       <Tooltip title="Rimuovi">
          <IconButton
              color="error"
              disabled={isDeletingPianAtt}
              onClick={() => openDeleteConfirmModal(row)}
            >
              <DeleteIcon />
            </IconButton>
        </Tooltip>

      </Box>


    ),


    renderTopToolbarCustomActions: ({ table }) => (
      <>

      <Stack
              direction="row"
              spacing={0}
              sx={{
                width: '60%',
                padding: '4px',
                alignItems: 'center',
              }}
            >

       <Box sx={{ width: '25%' }}>
          <Button sx={{ width: 160 }} variant="contained" onClick={openAddModal}>Nuovo</Button>
            {isDialogAddOpen && (<AddPianAtt2 open  onClose={() => {setIsDialogAddOpen(false); }}  /> )}
       </Box>

       <Box  sx={{ width: '25%'}}>   </Box>

        <Box sx={{ width: '25%' }}>
                <Button sx={{ width: 160 }} variant="contained" onClick={() => setIsDialogExporterOpen(true)} startIcon={<FileDownloadIcon />} > EXPORT DATI </Button>
                {isDialogExporterOpen && (
                    <PianAttExp
                      pagination={pagination}
                      columnFilters={columnFilters}
                      globalFilter={globalFilter}
                      sorting={sorting}
                      onClose={() => setIsDialogExporterOpen(false)}
                    />
                  )}
        </Box>


         <Box  sx={{ width: '25%'}}>
                <Button
                  sx={{ width: 160 }}
                  variant="contained"
                  onClick={() => {
                    setColumnFilters(draftColumnFilters);
                    saveTabSettings(columnVisibility, draftColumnFilters, sorting, pagination);
                  }}
                >
                  Applica Filtri
                </Button>
           </Box>

          </Stack>


        </>
      ),





      
      

    //rowCount: meta?.totalRowCount ?? 0,
    rowCount: count ?? 0,

    state: {
       isLoading: isLoadingPianAttDTO,
       // isSaving: isCreatingPianAttDTO || isUpdatingPianAttDTO || isDeletingPianAtt,
       isSaving: isDeletingPianAtt,
       showAlertBanner: isLoadingPianAttDTOError,
       showProgressBars: isFetchingPianAttDTO,

      columnFilters,
      globalFilter,
      pagination,
      sorting,
    },
  });


 // return (
 //
 //     <Box sx={{ mt: "60px" }}>
 //      {isLoadingPianAttDTO ? (
 //        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "500px" }}>
 //          <CircularProgress size={80} />
 //        </Box>
 //      ) : (
 //        <MaterialReactTable table={table} />
 //      )}
 //    </Box>
 //
 //  );

 return (
     <Box sx={{ mt: "60px" }}>
        <MaterialReactTable table={table} />

           <Backdrop
                  open={isDeletingPianAtt}
                  sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }}
                >
                  <CircularProgress color="inherit" />
                </Backdrop>

     </Box>
  );









};



const queryClient = new QueryClient();

export default ListaPianAtt;

// const validateRequired = (value: string) => !!value.length;
// const validateRequiredNum = (value: number) => !!value.toString().length;
// const validateEmail = (email: string) =>
//   !!email.length &&
//   email
//     .toLowerCase()
//     .match(
//       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
//     );

// function validatePianAtt(formdatiProg:PianAtt) {
//   return {
//   //  PianAtt: !validateRequiredNum(PrevTesta.PianAtt)  ? 'PianAtt is Required' : '',
//   //   tipo: !validateRequired(PrevTesta.tipo) ? 'Tipo is Required' : '',
//
//   };
// }
